import axios from 'axios';

export const state = {
   customers : []
}

export const getters = {
   customers : state => state.customers
}

export const mutations = {
   setCustomers(state, newValue){
      state.customers = newValue
   }
}

export const actions = {
   fetchCustomers({commit}) {
      axios.get('/customers').then(res => {
         commit('setCustomers', res.data.customers)
      })
   }
}